import React from "react";
import "./grid.css";
import akash from "../../images/institute.png";
import { AiFillStar } from "react-icons/ai";
import { BsBookmark } from "react-icons/bs";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { GoLocation } from "react-icons/go";
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import { baseUrl, baseLocal } from "../../context/BaseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Grid = (props) => {
  // console.log(id);

  const BookMarked = async (value) => {
    // try {
    const val = localStorage.getItem("user");

    if (!val) {
      toast.error("You are not logged in.");
      return;
    }

    const user = JSON.parse(val);
    const id = user.user._id;
    const token = user.token;

    const data = {
      institute_id: value,
      user_id: id,
    };

    const response = await fetch(
      `${baseUrl}/user/user_rights/postfollow/${id}`,
      {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      }
    );
    const result = await response.json();
    // if (result) {
    toast.success(result.msg, {
      position: toast.POSITION.TOP_LEFT,
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="grid-card mb-3">
        <div className="logo d-flex">
          <img src={props.image} alt="akash" />
          <div className="center d-flex">
            {/* <p>
                              Rating 4.2 <span className="num">(1562)</span>{" "}
                            </p> */}
            <div className="d-flex">
              <div className="">
                <h5 className="name pt-1">{props.name}</h5>
                <p className="p-abt" style={{ height: "63px" }}>
                  {parse(props.about)}
                </p>
              </div>

              <div className="d-flex ms-auto">
                <h6
                  className="ms-4"
                  onClick={() => BookMarked(props.institute_id)}
                >
                  {" "}
                  <BsBookmark />
                </h6>
              </div>
            </div>

            <div className="d-flex  ">
              <p className="location">
                {" "}
                <GoLocation /> {props.location}{" "}
              </p>
              <div className="ms-auto">
                <p>
                  Rating 4.2 <span className="num">(1562)</span>{" "}
                </p>
                <span>
                  <AiFillStar /> <AiFillStar /> <AiFillStar /> <AiFillStar />
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* <h5 className="name">{props.name}</h5>
                        <p className="p-abt">{props.about}</p> */}
        {/* <p className="location">
                          {" "}
                          <GoLocation /> {props.location}{" "}
                        </p> */}
      </div>
      <div className="buttons d-flex mt-0 mb-4">
        {/* <button className='view'>View Courses</button> */}
        <button className="more ms-auto">
          <Link to={`/institute/${props.institute_id}`}>Know More</Link>
        </button>
      </div>
    </>
  );
};

export default Grid;
